import React, { useState } from "react";
import styles from "../../../Meta.module.css";
import { FormHelperText, TextField } from "@mui/material";
import PageBackBtn from "../../../../../../../../components/Buttons/PageBackBtn";
import NewFormTextInput from "../../../../../../../../components/FormTextInput/NewFormTextInput";
import fbMetaIcon from "../../../../../../../../assets/images/fb-insta.svg";
import rightArrow from "../../../../../../../../assets/images/right-arrow-circle.svg";
import linkBlue from "../../../../../../../../assets/images/link-blue.svg";
import linkGrey from "../../../../../../../../assets/images/link-grey.svg";
import AutoCompleteFilter from "../../../../../../Reports/components/Filters/AutoCompleteFilter";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";
import nurtureFavIcon from "../../../../../../../../assets/images/nurture-fav-blue.svg";
import TestConnectionPopup from "./TestConnectionPopup";
import DeleteBtn from "../../../../../../../../components/Buttons/DeleteBtn";
import {
  getMetaDefaultFields,
  getMetaFields,
  getStreamFieldMapping,
  getStreams,
  resetMetaStatuses,
  resetMetaStreamById,
  updateMapedMetaFields,
} from "../../../../../service/IntegrationsSlice";
import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import asterikIcon from "../../../../../../../../assets/images/asterik.svg";
import { getSubDomainAccessStatus } from "../../../../../../../../components/RolePermissionAccess/RolePermissionAccess";
import asterikBlackIcon from "../../../../../../../../assets/images/asterisk-black.svg";

function ConnectFields(props: any) {
  const { setConnectStage } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const activeInstitute = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const {
    metaStream,
    metaFieldsLoading,
    metaFields,
    metaDefaultFieldsLoading,
    metaDefaultFields,
    metaFieldMapLoading,
    editMetaFieldMapSuccess,
    editMetaFieldMapLoading,
  } = useSelector((state: any) => state.appIntegrations);

  const [fields, setFields] = useState<any[]>([]);

  const handleTextFieldChange = (index: number, value: string) => {
    setFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index
          ? {
              ...field,
              nurtureFieldName: value,
              nurtureFieldKey: value?.toLowerCase().replace(/\s+/g, "_"),
              isNurtureFieldValid: value.trim() !== "",
            }
          : field
      )
    );
  };

  const handleAutoCompleteChange = (index: number, value: any) => {
    const lastValue =
      Array.isArray(value) && value.length > 0 ? value[value.length - 1] : null;

    setFields((prevFields) =>
      prevFields.map((field, i) =>
        i === index
          ? {
              ...field,
              metaFieldId: lastValue ? lastValue.id : "",
              metaFieldKey: lastValue ? lastValue.key : "",
              metaFieldLabel: lastValue ? lastValue.label : "",
              isMetaFieldValid:
                field?.nurtureFieldKey === "email" ||
                field?.nurtureFieldKey === "phone_Number"
                  ? true
                  : lastValue
                  ? lastValue?.id?.trim() !== ""
                  : false,
            }
          : field
      )
    );
  };

  const handleAddField = () => {
    const newField = {
      nurtureFieldName: "",
      nurtureFieldKey: "",
      metaFieldKey: "",
      metaFieldId: "",
      metaFieldLabel: "",
      isRequired: false,
      type: "text",
      isNurtureFieldValid: true,
      isMetaFieldValid: true,
      isRemovable: true,
    };

    setFields((prevFields) => [...prevFields, newField]);
  };
  const handleDeleteField = (index: number) => {
    setFields((prevFields) => prevFields.filter((_, i) => i !== index));
  };

  const hasValidEmail = !!fields?.find(
    (field) =>
      field?.nurtureFieldKey === "email" &&
      field?.metaFieldId?.trim() !== "" &&
      field?.nurtureFieldName?.trim() !== ""
  );
  const hasValidPhone = !!fields?.find(
    (field) =>
      field?.nurtureFieldKey === "phone_Number" &&
      field?.metaFieldId?.trim() !== "" &&
      field?.nurtureFieldName?.trim() !== ""
  );

  const isContactValid = hasValidEmail || hasValidPhone;

  const hasInvalidField = fields
    ?.filter(
      (item: any) =>
        item?.nurtureFieldKey !== "email" &&
        item?.nurtureFieldKey !== "phone_Number"
    )
    ?.some(
      (field) =>
        field?.metaFieldId?.trim() === "" ||
        field?.nurtureFieldName?.trim() === ""
    );

  const isSaveDisabled = !isContactValid || hasInvalidField;

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      const updatedFields = fields
        ?.filter((item: any) => item.metaFieldKey !== "")
        ?.map((item: any) => {
          return {
            nurtureFieldName: item.nurtureFieldName,
            nurtureFieldKey: item?.nurtureFieldKey,
            metaFieldName: item.metaFieldLabel,
            metaFieldId: item?.metaFieldId,
            metaFieldKey: item?.metaFieldKey,
            isRequired: item.isRequired,
            type: item?.type,
          };
        });

      const body = {
        metaStreamId: metaStream?.metaStreamId,
        metaFormId: metaStream?.metaFormId,
        fieldMapping: updatedFields,
        instituteId: activeInstitute?.id,
        createdById: authUser?.institute[0]?.id,
        createdByName: authUser?.firstName + " " + authUser?.lastName,
      };

      dispatch<any>(updateMapedMetaFields(body));
    } catch (error) {}
  };

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const streamId = urlSearchParams.get("streamId");

    if (activeInstitute?.id)
      dispatch<any>(
        getStreamFieldMapping({ id: activeInstitute?.id, streamId: streamId })
      );
    dispatch<any>(getMetaDefaultFields(""));
    dispatch<any>(getMetaFields({ streamId: streamId }));
  }, []);

  React.useEffect(() => {
    const updatedFields = metaDefaultFields?.map((item: any) => {
      return {
        nurtureFieldName: item?.label,
        nurtureFieldKey: item?.key,
        metaFieldKey: "",
        metaFieldId: "",
        metaFieldLabel: "",
        isRequired: item?.required,
        type: item?.type,
        isNurtureFieldValid: true,
        isMetaFieldValid: true,
        isRemovable:
          item?.key === "email" || item?.key === "phone_Number"
            ? false
            : !item?.required,
        nurtureFieldDisabled:
          item?.required ||
          item?.key === "email" ||
          item?.key === "phone_Number",
      };
    });
    setFields(updatedFields);
  }, [metaDefaultFields]);

  React.useEffect(() => {
    if (editMetaFieldMapSuccess !== true && editMetaFieldMapSuccess !== false) {
      setConnectStage(0);
      dispatch<any>(
        getStreams({
          id: activeInstitute?.id,
          status: "",
          branchId: hasAllBranchAccess ? "" : userById?.branchId,
        })
      );
      dispatch<any>(resetMetaStatuses());
      dispatch<any>(resetMetaStreamById());
      const urlSearchParams = new URLSearchParams(window.location.search);
      urlSearchParams.delete("streamId");
      const newUrl = `${
        window.location.pathname
      }?${urlSearchParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    }
  }, [editMetaFieldMapSuccess]);

  return (
    <div>
      <div className={styles.connectHead}>
        <PageBackBtn iconOnly={true} onClick={() => setConnectStage(1)} />
        <div className={styles.streamFieldName}>
          <div className={styles.fieldBox}>
            <NewFormTextInput
              value={metaStream?.metaStreamName}
              validate={false}
              error={false}
              disabled={true}
              placeholder="Stream name"
            />
          </div>
        </div>
      </div>

      <div className={styles.connectFieldsWrap}>
        <div className={styles.connectTitle}>Field Mapping</div>
        <div className={styles.connectFormHead}>
          <div className={styles.connectFormHeadItem}>
            <img src={fbMetaIcon} alt="icon" />
            Nurture CRM &gt;&gt; New Stream
          </div>
          <div className={styles.connectFormHeadItem}>
            <img src={rightArrow} alt="icon" />
          </div>
          <div className={styles.connectFormHeadItem}>
            <img src={nurtureFavIcon} alt="icon" />
            Nurture CRM
          </div>
        </div>
        <div
          className={styles.connectFieldsSplit}
          style={{ marginBottom: "0" }}
        >
          <div className={styles.connectFieldsSplitLeft}>
            <div className={styles.connectTitle}>Fields in nurture</div>
          </div>
          <div className={styles.connectFieldsSplitCenter}></div>
          <div className={styles.connectFieldsSplitRight}>
            <div className={styles.connectTitle}>Fields in Meta Ads</div>
          </div>
        </div>

        {fields?.map((item: any, index: number) => (
          <div className={styles.connectFieldsSplit} key={index}>
            <div className={styles.connectFieldsSplitLeft}>
              <TextField
                fullWidth
                value={item?.nurtureFieldName}
                onChange={(e) => handleTextFieldChange(index, e.target.value)}
                error={!item?.isNurtureFieldValid}
                sx={{
                  fontFamily: "Poppins",
                  "& .MuiOutlinedInput-input": {
                    padding: "8px 14px",
                    fontSize: "13px",
                  },
                }}
                helperText={
                  !item?.isNurtureFieldValid ? "Please fill valid value" : ""
                }
                disabled={item?.nurtureFieldDisabled}
                InputProps={{
                  endAdornment: item?.nurtureFieldDisabled ? (
                    <img
                      src={
                        item?.nurtureFieldKey === "email" ||
                        item?.nurtureFieldKey === "phone_Number"
                          ? asterikBlackIcon
                          : asterikIcon
                      }
                      alt="icon"
                      style={{ width: "11px" }}
                    />
                  ) : null,
                }}
              />
            </div>
            <div className={styles.connectFieldsSplitCenter}>
              <div className={styles.fieldConnector}>
                <div
                  className={styles.fieldConnectorLine}
                  style={{
                    borderBottom:
                      item?.metaFieldId === ""
                        ? "1px dashed #8995a1"
                        : "1px dashed #0766fe",
                  }}
                ></div>
                <div
                  className={`${styles.fieldConnectorIconBox} ${
                    item?.metaFieldId !== "" ? styles.active : ""
                  }`}
                  style={{
                    background:
                      item?.metaFieldId === "" ? "#DFE2E4" : "rgb(205 224 255)",
                  }}
                >
                  <img
                    src={item?.metaFieldId === "" ? linkGrey : linkBlue}
                    alt="icon"
                  />
                </div>
              </div>
            </div>
            <div className={styles.connectFieldsSplitRight}>
              <div className={styles.metaFieldWrap}>
                <AutoCompleteFilter
                  listType="FACEBOOK"
                  options={metaFields?.filter((option: any) => {
                    const isUnique = !fields?.some(
                      (f, i) => f.metaFieldId === option?.id && i !== index
                    );

                    if (item?.type === "email") {
                      return isUnique && option?.type === "EMAIL";
                    }

                    if (item?.type === "phone") {
                      return isUnique && option?.type === "PHONE";
                    }

                    return isUnique;
                  })}
                  width="100%"
                  multiSelect={true}
                  value={
                    item?.metaFieldId
                      ? [
                          {
                            id: item.metaFieldId,
                            key: item.metaFieldKey,
                            label: item.metaFieldLabel,
                          },
                        ]
                      : []
                  }
                  onChange={(event: any, newValue: any) =>
                    handleAutoCompleteChange(index, newValue)
                  }
                  disableClearable={true}
                  validState={item?.isMetaFieldValid}
                />
                {!item?.isMetaFieldValid && (
                  <FormHelperText error>
                    {item?.isRequired
                      ? "Please fill required field"
                      : "Please fill valid value"}
                  </FormHelperText>
                )}
              </div>
              {item?.isRemovable && (
                <div
                  style={{
                    minWidth: "22px",
                    marginBottom: !item?.isMetaFieldValid ? "21px" : "0px",
                  }}
                >
                  <DeleteBtn onClick={() => handleDeleteField(index)} />
                </div>
              )}
            </div>
          </div>
        ))}
        {fields?.length < metaFields?.length && (
          <div className={styles.connectFieldsSplit}>
            <div className={styles.connectFieldsSplitLeft}>
              <button
                className={styles.metaFieldAddBtn}
                onClick={handleAddField}
              >
                +
              </button>
              <div className={styles.metaFieldWrap}>
                <TextField
                  fullWidth
                  sx={{
                    fontFamily: "Poppins",
                    color: "#000",
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 14px",
                      fontSize: "13px",
                      color: "#000",
                    },
                    "&& fieldset": {
                      color: "#000",
                    },
                  }}
                  disabled
                  placeholder="Name Of Parameter"
                />
              </div>
            </div>
            <div className={styles.connectFieldsSplitCenter}>
              <div className={styles.fieldConnector}>
                <div
                  className={styles.fieldConnectorLine}
                  style={{
                    borderBottom: "1px dashed #8995a1",
                  }}
                ></div>
                <div
                  className={`${styles.fieldConnectorIconBox} `}
                  style={{
                    background: "#DFE2E4",
                  }}
                >
                  <img src={linkGrey} alt="icon" />
                </div>
              </div>
            </div>
            <div className={styles.connectFieldsSplitRight}>
              <div className={styles.metaFieldWrap}>
                <TextField
                  fullWidth
                  sx={{
                    fontFamily: "Poppins",
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 14px",
                      fontSize: "13px",
                    },
                    "&& fieldset": {
                      background: "#F9F9F9",
                    },
                  }}
                  disabled
                  placeholder="Select Value"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={styles.connectFormBtnsWrap}>
        {/* <TestConnectionPopup disabled={isSaveDisabled} /> */}
        <SaveBtn
          disabled={isSaveDisabled || editMetaFieldMapLoading}
          buttonText={"save And Publish"}
          onClick={handleSubmit}
          loader={editMetaFieldMapLoading}
        />
      </div>
    </div>
  );
}

export default ConnectFields;
